import React, { useCallback } from 'react'
import { WbTabs, WbTabBar, WbTab } from '@workbench/react/dist'

export const useOnChangeTab = (setStepNumber: (step: number) => void) =>
  useCallback(
    ({ detail }: { detail: string }) => {
      const stepMatch = detail.match(/STEP_(\d+)/)
      const stepName = stepMatch ? parseInt(stepMatch[1], 10) : null

      if (stepName !== null && !isNaN(stepName)) {
        setStepNumber(stepName)
      }
    },
    [setStepNumber]
  )

interface WizardTabsProps {
  stepNames: string[]
  stepNumber: number
  maxVisited: number
  isValid: boolean
  setStepNumber: (step: number) => void
}

export const WizardTabs: React.FunctionComponent<WizardTabsProps> = ({
  stepNames,
  stepNumber,
  maxVisited,
  isValid,
  setStepNumber,
}) => {
  const onChange = useOnChangeTab(setStepNumber)

  return (
    <WbTabs selected={`STEP_${stepNumber}`} onWbchange={onChange}>
      <WbTabBar>
        {stepNames.map((step, index) => (
          <div key={index}>
            <WbTab
              key={`${index}-${step}`}
              name={`STEP_${index}`}
              disabled={index > maxVisited || (!isValid && index > stepNumber)}
            >
              {step}
            </WbTab>
          </div>
        ))}
      </WbTabBar>
    </WbTabs>
  )
}
